<template>
	<div>
		<slot :listadoPagosPersona="listadoPagosPersona" :registrarPagoAbierto="registrarPagoAbierto" :registrarPagoCargoAbono="registrarPagoCargoAbono" :registrarPagoServicio ="registrarPagoServicio"></slot>
		<form id="consolidar-pago-form">			
			<div id="conciliacion-de-pagos-modal" class="modal fade" tabindex="-1">
				<div class="modal-dialog modal-dialog-centered modal-xl">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Conciliacion de pagos</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="component-searchbar w-100">
								<div style="max-height: 200px;">									
									<div v-for="persona in info" class="item" :key="persona.id">										
										<div>
											<p v-text="persona.nombre_completo" class="m-0"></p>
											<input type="hidden" name="persona_id_seleccionado" value="persona.id">
										</div>						
									</div>
								</div>								
								<div class="card mt-3">
									<div class="card-header">
										<h5 class="card-title">{{ nombre_persona }}</h5>		
									</div>
									<div class="card-body">
										<div class="row mb-4">
											<div v-if="ciclosEscolaresOpciones > 0" class="col-xs-12 col-md-12 col-lg-12 mb-3">
												<label for="ciclo_escolar_id">
													<span class="text-truncate">
														Ciclo escolar
													</span>
													<i class="fas fa-shield-alt"></i>
												</label>
												<select class="form-control" name="ciclo_escolar_id" id="ciclo_escolar_id" v-model="ciclo_escolar_id" @change="seleccionarCicloEscolar($event)">
													<option value="" selected="" hidden>Seleccionar</option>
													<option v-for="cicloEscolar in ciclosEscolares" :value="cicloEscolar.id" :key="cicloEscolar.id">
														{{ cicloEscolar.text }}
													</option>
												</select>				
											</div>												
											<div class="col-xs-12 col-md-4 col-lg-4">
												<label for="fecha_pago">
													<span class="text-truncate">
														Fecha
													</span>
													<i class="fas fa-shield-alt"></i>
												</label>											
												<input type="date" class="form-control" v-model="fecha_pago" @change="seleccionarFecha($event)"/>									
											</div>											
											<div class="col-xs-12 col-md-8 col-lg-8" v-if="origen =='registrar-pago-libre'">
												<label for="monto">
													<span class="text-truncate">
														Monto
													</span>
													<i class="fas fa-shield-alt"></i>
												</label>
												<input type="text" class="form-control" v-model="monto" placeholder="0">		
											</div>
										</div>
										<div class="row">
											<div class="col-xs-12 col-md-4 col-lg-4">
												<label for="metodo_pago">
													<span class="text-truncate">
														Metodo de pago
													</span>
													<i class="fas fa-shield-alt"></i>
												</label>
												<select class="form-control" name="metodo_pago" v-model="metodo_pago" @change="seleccionarMetodoPago($event)">
													<option value="" selected="" hidden>Seleccionar</option>
													<option v-for="metodoPago in metodos" :value="metodoPago.id" :key="metodoPago.id">
														{{ metodoPago.text }}
													</option>
												</select>				
											</div>										
											<div class="col-xs-12 col-md-8 col-lg-8">
												<label for="codigo_detalle_id">
													<span class="text-truncate">
														Concepto
													</span>
													<i class="fas fa-shield-alt"></i>
												</label>
												<select class="form-control" name="codigo_detalle_id" v-model="codigo_detalle_id" @change="seleccionarConcepto($event)">
													<option value="" selected="" hidden>Seleccionar</option>
													<option v-for="opcion in opciones" :value="opcion.id" :key="opcion.id">
														{{ opcion.text }}
													</option>
												</select>				
											</div>
											<div class="col-xs-12 col-md-4 col-lg-4 mt-3">
												<label for="autorizacion_pago">
													<span class="text-truncate">
														No. autorización del pago
													</span>
													<i class="fas fa-shield-alt"></i>
												</label>
												<input type="text" class="form-control" v-model="autorizacion_pago" placeholder="">				
											</div>
										</div>	
										<div class="row mt-4" v-if="ciclosEscolaresOpciones > 0">
											<div class="col-12 mb-3">
												<p class="text-left">
													<h5>Descuentos</h5>
												</p>
												<hr>
											</div>
											<div class="col-xs-12 col-md-4 col-lg-14 mb-1">
												<label for="opcion_descuento">
													<span class="text-truncate">
														¿Desea registrar descuento?
													</span>
												</label>
												<select class="form-control" name="opcion_descuento" v-model="opcion_descuento" @change="seleccionarOpcionDescuento($event)">
													<option value="" selected="" hidden>Seleccionar</option>
													<option v-for="opcion in opcionesDescuentos" :value="opcion.id" :key="opcion.id">
														{{ opcion.text }}
													</option>
												</select>				
											</div>
											<div class="col-xs-12 col-md-8 col-lg-8 mb-3 descuentos-invisible" hidden>
												<label for="descuento_id">
													<span class="text-truncate">
														Descuentos
													</span>
												</label>
												<select class="form-control" name="descuento_id" v-model="descuento_id" @change="seleccionarDescuento($event)">
													<option value="" selected="" hidden>Seleccionar</option>
													<option v-for="descuento in descuentos" :value="descuento.id" :key="descuento.id">
														{{ descuento.text }}
													</option>
												</select>				
											</div>
											<div class="col-xs-12 col-md-12 col-lg-12 descuentos-invisible" v-if="origen =='registrar-pago-libre'" hidden>
												<label for="monto_descuento">
													<span class="text-truncate">
														Monto
													</span>
													<i class="fas fa-shield-alt"></i>
												</label>
												<input type="text" class="form-control" v-model="monto_descuento" placeholder="0">		
											</div>	
										</div>
										<div class="row">
											<div class="col-12 text-right mt-4">				
												<button type="button" class="btn btn-sm btn-primary" @click="agregarPago($event)">Seleccionar</button>								
											</div>											
										</div>
									</div>
								</div>
								<div class="mt-3" v-if="pagos.length > 0 ">
									<div class="card mt-3 mb-3" v-for="pago in pagos" :key="`${pago.persona_id}-${Math.random().toString(36).slice(-5)}`" v-show="pagos.length >= 1">	
										<button data-dismiss="alert" data-target="#cerrar" type="button" class="mt-3 mr-3 text-right close" aria-label="Close" @click="eliminarPago(pago)">
											<span aria-hidden="true">&times;</span>
										</button>
										<div class="card-body">
											<div class="row font-italic">
												<div class="col-10" v-if="pago.descuentos.monto">
													<h5 v-if="pago.descuentos.monto">{{pago.descuentos.descripcion}} - {{pago.descuentos.monto_con_formato}}</h5>												
												</div>
												<div class="col-10"><h5>{{pago.desc_concepto}}</h5></div>
												<div class="col-10"><h5>{{pago.metodo_pago}} - Autorización: {{pago.autorizacion_pago}}</h5></div>
												<div class="col-10"><h5>{{pago.fecha_pago}}</h5></div>
												<div class="col-10"><h5>{{pago.monto_con_formato}}</h5></div>
											</div>											
										</div>			
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="submit" class="btn btn-primary btn-sm" id="btn-conciliar-pago">Guardar y salir</button>
						</div>
					</div>
				</div>
			</div>
		</form>	
	</div>
</template>
<script>
import Axios from 'axios';
export default {
	props: ['placeholder', 'route', 'mostrarCiclosEscolares', 'id'],
	data() {
		return {
			listadoPagosPersona: {},			
			codigo_detalle_id: 0,
			ciclo_escolar_id: 0,
			metodo_pago_id: 0,
			regla_cobro_id: 0,			
			institucion_id: 0,			
			descuento_id: 0,			
			registro_id: 0,
			persona_id: 0,
			autorizacion_pago: '',
			opcion_descuento: '',
			monto_descuento: '',
			nombre_persona: '',
			desc_descuento: '',
			desc_concepto: '',
			tipo_usuario: '',
			metodo_pago: '',			
			fecha_pago: '',
			deducible: '',
			prioridad: '',
			concepto: '',
			origen: '',
			texto: '',
			monto: '',
			opcionesDescuentos: [],
			ciclosEscolares: [],
			descuentos: [],
			opciones: [],
			metodos: [],
			errores: [],
			pagos: [],			
			info: [],
		}
	},
	computed: {
		computed_seach_id() { if (this.id != undefined) { return this.id; } return ('nsearch-' + this._uid); },
		ciclosEscolaresOpciones() { return Object.entries(this.ciclosEscolares).length; },
	},
	mounted() {

		const vm = this;
		const form = $('#consolidar-pago-form');		
		form.submit(function(event) { 
			event.preventDefault(); vm.conciliarPagosPersona(); 
		});
	},
	methods: {	
		registrarPagoAbierto(persona) {	
			if (persona.length <= 0) { return; };
			Axios.get('/conciliacion-de-pagos/pagos', {
				params: {					
					persona_id: persona.id, 
					texto: this.texto
				}}).then(response => { 
					if (response.data.length <=0 ) { toastr["warning"]('No se encontraron conceptos para el pago'); return; } 		
					this.codigo_detalle_id = 0;
					this.ciclo_escolar_id = 0;
					this.autorizacion_pago = '';
					this.desc_descuento = '';	
					this.desc_concepto = '';	
					this.tipo_usuario = '';
					this.persona_id = '';
					this.fecha_pago = '';
					this.prioridad = '';					
					this.deducible = '';					
					this.concepto = '';					
					this.monto = '';
					this.texto = '';
					this.opcionesDescuentos = [];
					this.ciclosEscolares = [];
					this.descuentos = [];
					this.opciones = [];
					this.pagos = [];
					this.info = [];

					const persona = response.data[0];

					if (persona) {

						this.ciclosEscolares = persona.ciclos_escolares;
						this.opcionesDescuentos = persona.opciones_descuentos;
						this.nombre_persona = persona.nombre_completo;
						this.descuentos = persona.descuentos;
						this.metodos = persona.metodos_pagos;
						this.origen = 'registrar-pago-libre';
						this.prioridad = persona.prioridad;
						this.opciones = (persona.opciones.length <= 0) ?  [{'id' : 0, 'text' : 'Sin resultados'}] : persona.opciones;
						
						this.nivel_academico_id = persona.nivel_academico_id;
						this.ciclo_escolar_id = persona.ciclo_escolar_id;
						this.institucion_id = persona.institucion_id;
						this.programa_id = persona.programa_id;						
						this.persona_id = persona.id;

						this.info = persona;						
					}	

				}).catch(e => { 

					if (e.response.data && e.response.data.message) { 

						toastr["error"](e.response.data.message, 'Error'); 

					} else {

						toastr["error"](e, 'Error al obtener los conceptos'); 
					}
				});

			},
			registrarPagoCargoAbono(persona) {
				if (persona.length <= 0) { return; };
				Axios.get('/conciliacion-de-pagos/cargos', {
					params: {					
						cargos_generales: true, 
						persona_id: persona.id, 
						texto: this.texto

					}}).then(response => { 

						if (response.data.length <=0 ) { 

							toastr["warning"]('No se encontraron conceptos para el pago'); return; 
						} 

						const persona = response.data[0];

						if (persona) {

							this.codigo_detalle_id = 0;
							this.ciclo_escolar_id = 0;
							this.regla_cobro_id = 0;
							this.autorizacion_pago = '';
							this.desc_descuento = '';	
							this.desc_concepto = '';	
							this.tipo_usuario = '';
							this.persona_id = '';
							this.fecha_pago = '';
							this.prioridad = '';					
							this.deducible = '';					
							this.concepto = '';					
							this.monto = '';
							this.texto = '';
							this.ciclosEscolares = [];
							this.opciones = [];
							this.pagos = [];
							this.info = [];

							this.nombre_persona = persona.nombre_completo;
							this.metodos = persona.metodos_pagos;
							this.opciones = (persona.opciones.length <= 0) ?  [{'id' : 0, 'text' : 'Sin resultados'}] : persona.opciones;
							this.origen = 'registrar-pago';

							this.nivel_academico_id = persona.nivel_academico_id;
							this.ciclo_escolar_id = persona.ciclo_escolar_id;
							this.institucion_id = persona.institucion_id;
							this.programa_id = persona.programa_id;						
							this.persona_id = persona.id;

						}

					}).catch(e => { 

						if (e.response && e.response.data && e.response.data.message) { 

							toastr["error"](e.response.data.message, 'Error'); 

						} else {

							toastr["error"](e, 'Error al obtener los conceptos'); 
						}

					});
				},
				registrarPagoServicio(persona) {	
					if (persona.length <= 0) { return; };
					Axios.get('/conciliacion-de-pagos/servicios', {
						params: {							
							cargos_servicios: true, 
							persona_id: persona.id, 
							texto: this.texto
						}}).then(response => { 

							if (response.data.length <=0 ) { toastr["warning"]('No se encontraron conceptos para el pago'); return; } 

							const persona = response.data[0];

							if (persona) {				

								this.codigo_detalle_id = 0;
								this.ciclo_escolar_id = 0;
								this.autorizacion_pago = '';	
								this.desc_descuento = '';	
								this.desc_concepto = '';	
								this.tipo_usuario = '';
								this.persona_id = '';
								this.fecha_pago = '';
								this.prioridad = '';					
								this.deducible = '';					
								this.concepto = '';					
								this.monto = '';
								this.texto = '';
								this.ciclosEscolares = [];
								this.opciones = [];
								this.pagos = [];
								this.info = [];

								this.nombre_persona = persona.nombre_completo;
								this.metodos = persona.metodos_pagos;
								this.opciones = (persona.opciones.length <= 0) ?  [{'id' : 0, 'text' : 'Sin resultados'}] : persona.opciones;								
								this.origen = 'registrar-pago-servicio';

								this.nivel_academico_id = persona.nivel_academico_id;
								this.ciclo_escolar_id = persona.ciclo_escolar_id;
								this.institucion_id = persona.institucion_id;
								this.programa_id = persona.programa_id;						
								this.persona_id = persona.id;								

							}

						}).catch(e => { 
							if (e.response.data && e.response.data.message) { 
								toastr["error"](e.response.data.message, 'Error'); 
							} else { 
								toastr["error"](e, 'Error al obtener los conceptos'); 
							}
						});
					}, 
					agregarPago(e) {	

						this.validarFormulario(e);

						if (this.errores.length > 0) {

							return;
						} 

						const formatter = new Intl.NumberFormat('en-ES', {
							style: 'currency',
							currency: 'MXN',
						});

						this.pagos.push({
							monto_con_formato: Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(this.monto),				
							ciclo_escolar_id: this.ciclo_escolar_id != 0 ? this.ciclo_escolar_id : $('#ciclo_escolar_id').val(),
							nivel_academico_id: this.nivel_academico_id,
							codigo_detalle_id: this.codigo_detalle_id,
							regla_cobro_id: this.regla_cobro_id,
							institucion_id: this.institucion_id,
							autorizacion_pago: this.autorizacion_pago,
							metodo_pago_id: this.metodo_pago_id,
							desc_concepto: this.desc_concepto,
							tipo_usuario: this.tipo_usuario,
							registro_id: this.registro_id,
							programa_id: this.programa_id,
							metodo_pago: this.metodoPago,
							fecha_pago: this.fecha_pago,
							persona_id: this.persona_id,						
							deducible: this.deducible,
							concepto: this.concepto,
							origen: this.origen,
							monto: this.monto,
							descuentos: {
								monto_con_formato: Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(this.monto_descuento),
								codigo_detalle_id: this.descuento_id,
								descripcion: this.desc_descuento,
								monto: this.monto_descuento
							} 
						});

						this.autorizacion_pago = '';
						this.opcion_descuento = '';
						this.monto_descuento = '';
						this.desc_descuento = '';
						this.desc_concepto = '';
						this.metodo_pago = '';
						this.fecha_pago = '';
						this.concepto = '';			
						this.monto = '';
						this.codigo_detalle_id = 0;
						this.descuento_id = 0;
						this.registro_id = 0;



					},
					eliminarPago(pago) {

						this.pagos = this.pagos.filter(item => item.codigo_detalle_id !== pago.codigo_detalle_id);
					},	 
					seleccionarConcepto(e) {	

						const codigoDetalleId = this.opciones.find(opcion => opcion.id == event.target.value).codigo_detalle_id ?
						this.opciones.find(opcion => opcion.id == event.target.value).codigo_detalle_id :
						null;

						const concepto = this.opciones.find(opcion => opcion.id == event.target.value).concepto ?
						this.opciones.find(opcion => opcion.id == event.target.value).concepto :
						null;

						const monto = this.opciones.find(opcion => opcion.id == event.target.value).monto ? 
						this.opciones.find(opcion => opcion.id == event.target.value).monto :
						null;

						this.prioridad = this.opciones.find(opcion => opcion.id == event.target.value).prioridad ?
						this.opciones.find(opcion => opcion.id == event.target.value).prioridad :
						null;

						this.regla_cobro_id = this.opciones.find(opcion => opcion.id == event.target.value).registro_id ?
						this.opciones.find(opcion => opcion.id == event.target.value).registro_id :
						null;

						this.desc_concepto = event.target.options[event.target.options.selectedIndex].text;
						this.codigo_detalle_id = codigoDetalleId;
						this.registro_id = event.target.value;
						this.concepto = concepto;

						if (this.origen == 'registrar-pago' || this.origen == 'registrar-pago-servicio') {	

							this.monto = monto;		

							if (this.origen == 'registrar-pago-servicio') {


								this.deducible = this.opciones.find(opcion => opcion.id == event.target.value).deducible ?
								this.opciones.find(opcion => opcion.id == event.target.value).deducible :
								null;	

							}					

						}


						if (this.origen == 'registrar-pago-servicio' || this.origen != 'registrar-pago') {


							this.deducible = this.opciones.find(opcion => opcion.id == event.target.value).deducible ?
							this.opciones.find(opcion => opcion.id == event.target.value).deducible :
							null;	

						}

					},
					seleccionarMetodoPago(e) {

						this.metodoPago = event.target.options[event.target.options.selectedIndex].text;
						this.metodo_pago_id = event.target.value;
					},
					seleccionarCicloEscolar(e) {

						this.ciclo_escolar_id = event.target.value;
					},	
					seleccionarFecha(e) {	
						const fechaPago = e.target.value;
						if (fechaPago && this.persona_id && (this.origen && this.origen == 'registrar-pago')) {
							Axios.get(`/conciliacion-de-pagos/cargos`, { 
								params: {									
									persona_id: this.persona_id, 
									cargos_generales: true,
									fecha_pago: fechaPago, 
									texto: this.texto
								}
							}).then(response => { 
								if (response.data.length <=0 ) { 
									toastr["warning"]('No se encontraron conceptos para el pago'); return; 
								}
								const persona = response.data[0];
								if (persona) {			
									this.nombre_persona = persona.nombre_completo;
									this.metodos = persona.metodos_pagos;
									this.opciones = (persona.opciones.length <= 0) ?  [{'id' : 0, 'text' : 'Sin resultados'}] : persona.opciones;
									this.persona_id = persona.id;

								}

							}).catch(e => { if (e.response.data && e.response.data.message) { toastr["error"](e.response.data.message, 'Error'); } else { toastr["error"](e, 'Error al obtener los conceptos'); } });
						} 
					},
					seleccionarOpcionDescuento(e) {

						if ((event.target.value == 'si')) {

							$('.descuentos-invisible').removeAttr('hidden');

						} else if (event.target.value == 'no') {

							$('.descuentos-invisible').attr('hidden', true);

						}				

					},
					seleccionarDescuento(e) {

						this.desc_descuento = event.target.options[event.target.options.selectedIndex].text;
						this.descuento_id = event.target.value;

					},	
					validarFormulario(e) {			

						this.errores = [];

						if (!this.fecha_pago || !this.codigo_detalle_id || !this.metodo_pago || !this.autorizacion_pago) {

							this.errores.push('Favor de proporcionar la información que se requiere');							
							toastr["error"]('Favor de proporcionar la información que se requiere');

						} else if (!this.fecha_pago) {

							this.errores.push('La fecha de pago es un campo obligatorio');							
							toastr["error"]('La fecha de pago es un campo obligatorio');

						} else if (!this.codigo_detalle_id) {

							this.errores.push('El concepto es un campo obligatorio');							
							toastr["error"]('El concepto es un campo obligatorio');

						} else if (!this.metodo_pago) {

							this.errores.push('El método de pago es un campo obligatorio');							
							toastr["error"]('El método de pago es un campo obligatorio');

						} else if (!this.autorizacion_pago) {

							this.errores.push('La autorización del pago es un campo obligatorio');							
							toastr["error"]('La autorización del pago es un campo obligatorio');

						} else  {

							this.errores = [];							
						}					

						e.stopPropagation();

					},										
					conciliarPagosPersona() {	

						$('#btn-conciliar-pago').addClass('disabled');	

						let base = {persona_id: this.persona_id };
						let params = Object.assign(base, {"pagos": this.pagos});	

						Axios.post(`/conciliacion-de-pagos/${this.origen}/${this.persona_id}/persona`, params).then(response => {

							$('#btn-conciliar-pago').toggleClass('disabled');
							$('#conciliacion-de-pagos-modal').modal('hide');
							$('#consolidar-pago-form').trigger('reset');
							this.ciclosEscolares = [];
							this.errores = [];
							this.opciones = [];
							this.desc_concepto = '';
							this.nombre_persona = '';
							this.metodo_pago = '';
							this.fecha_pago = '';
							this.concepto = '';
							this.origen = '';
							this.monto = '';
							this.info = [];
							this.pagos = [];
							this.ciclo_escolar_id = 0;
							this.regla_cobro_id = 0;
							this.persona_id = 0;
							toastr["success"]('Pago registrado correctamente');

						}).catch(e => { if (e.response.data && e.response.data.message) { toastr["warning"](`${e.response.data.message}`, 'Error'); } else { toastr["error"](e, 'Ocurrió un problema inesperado al conciliar el pago'); } });

					}
				}
			}

			</script>
